// extracted by mini-css-extract-plugin
export var fadeIn = "_ia-1";
export var modalContent = "_ia-3";
export var overlay = "_ia-0";
export var popoverContent = "_ia-2";
export var results = "_ia-5";
export var searchInputWrapper = "_ia-4";